import React from "react"
import { firestore } from "../../core"
import { useSelections } from "popopo-lib-front/firestore-access"
import { NavLink } from "react-router-dom"
import { User } from "firebase/auth"
import { LiveId, SpaceKey } from "popopo-msg"
import { Paths } from "../../paths"

export const SelectionList = (props: { firebase: User; spaceKey: SpaceKey; liveId: LiveId }) => {
  const selections = useSelections(firestore, props.spaceKey, props.liveId, 100)

  return (
    <>
      <ul className="list-group w-100">
        {selections === "loading" ? (
          <li>
            <i className="fas fa-spin fa-spinner" />
          </li>
        ) : selections.length === 0 ? (
          <li>投稿募集は1つも存在しません。</li>
        ) : (
          selections.map((selection) => (
            <li key={selection.id} className="list-group-item">
              <NavLink to={Paths.spaces.space.lives.live.selections.selection.getPath(props.spaceKey, props.liveId, selection.id)}>
                ID: {selection.id} (title: {selection.title}, kind: {selection.kind}, status: {selection.status})
              </NavLink>
            </li>
          ))
        )}
      </ul>
    </>
  )
}
